import ajax from '@/lib/ajax';

class PaymentModule {
  namespaced = true;
  state = {
    orderId: '',
    pGuid: '',
    response: '',
  };
  mutations = {
    clearResponse(state) {
      state.response = ''; // Clear the response state
    },
  };
  actions = {
    async addOrder({ state }, payload: any) {
      let res = await ajax.post(
        '/api/services/app/Booking/AddOrder',
        payload.data
      );

      
      const orderId = res.data.result.orderId;
      const pGuid = res.data.result.pGuid;
      const response = res.data.result.response;
      
      state.orderId = orderId;
      state.pGuid = pGuid;
      state.response = response;

      return orderId;
    },
  };
}
const paymentModule = new PaymentModule();
export default paymentModule;
